import { legacyPost } from '../legacy-client';

/**
 * Товар готовый к выписке накладной
 */
export interface PaidOrderItem {
  id: string;
  company: string;
  name: string;
  userlist_id?: string;
}

interface PaidOrdersResponse {
  orders: PaidOrderItem[];
}

interface OrderWaybillResponse {
  success: boolean;
}

export const legacyWaybillsApi = {
  /**
   * Получить заказы готовые к выписке накладных
   * @param clientNames - имена клиентов для фильтрации
   * @param includeUserOrders - включить заказы созданные пользователем
   */
  getPaidOrders: async (
    clientNames: string[],
    includeUserOrders = false,
  ): Promise<PaidOrderItem[]> => {
    const response = await legacyPost<PaidOrdersResponse>('getPaidOrders', {
      clientNames,
      includeUserOrders: includeUserOrders ? '1' : '0',
    });
    return response.orders || [];
  },

  /**
   * Заказать накладную
   * @param orderId - ID заказа (savel.id)
   */
  orderWaybill: async (orderId: number): Promise<void> => {
    await legacyPost<OrderWaybillResponse>('orderWaybill', { orderId });
  },
};
